import React from 'react'
import './jobItem.scss'
import moment from 'moment'

let time = Date.parse(new Date())
function ActivityStatus(props) {
  if (props.item.startTime < time < props.item.endTime) {
    return <div className="jobItem_status">进行中</div>
  } else {
    return <div className="jobItem_status end">已结束</div>
  }
}
export default class JobItem extends React.Component {
  render() {
    let item = this.props.item
    return (
      <div
        className="jobItem"
        onClick={() => {
          window.location.href = item.pcUrl
        }}
      >
        <div className="jobItem_left">
          <img
            className="specialLogo"
            alt=""
            src={
              item.imgUrl
                ? item.imgUrl
                : '//pic1.58cdn.com.cn/nowater/cxnomark/n_v2b2b3eb2abc114b9eb06aa7e8c2ae936d.jpg'
            }
          ></img>
          <div className="jobItem_center">
            <div className="jobItem_title">{item.pageTitle}</div>
            <div className="jobItem_middle">
              <div className="jobItem_local">
                <img
                  className="localLogo"
                  alt=""
                  src={require('../../assets/img/local4.png')}
                ></img>
                <div className="localCity">{item.province}</div>
              </div>
              <div className="jobItem_company">
                <img
                  className="companyLogo"
                  alt=""
                  src={require('../../assets/img/qyIcon2.png')}
                ></img>
                <div className="companyScale">
                  <div>企业规模：</div>
                  <div className="companyNum">{item.maxEntNum}</div>
                  <div>家</div>
                </div>
              </div>
            </div>
            <div className="jobItem_bottom">
              <ActivityStatus item={item} />
              <div className="jobItem_time">
                <div className="startTime">
                  {moment(parseInt(item.startTime)).format('YYYY.MM.DD')}
                </div>
                <div>-</div>
                <div className="endTime">
                  {moment(parseInt(item.endTime)).format('YYYY.MM.DD')}
                </div>
              </div>
            </div>
            <div className="jobItem_organizer">
              <div className="name">主办单位：</div>
              <div className="organizer">{item.organizer}</div>
            </div>
          </div>
        </div>
        <img
          className="detailsButton"
          alt=""
          src={require('../../assets/img/details3.png')}
        ></img>
      </div>
    )
  }
}
